import { dynamicLoader } from '~/utils';

export const CashflowPage = dynamicLoader({
  name: 'CashflowPage',
  importFunc: () => import('./cashflow'),
});